<template>
    <div
        class="payment-modal-content -first"
        :style="{ marginTop: isMobile ? '1rem' : '2rem' }"
    >
        <div v-if="isMobile" class="subtitle">Moduły szkolenia</div>
        <div
            :class="[
                isMobile ? null : moduleStatus(courseModule),
                isMobile ? 'mobile' : 'payments-form-block'
            ]"
            v-for="(courseModule, index) in courseModules"
            :key="index"
        >
            <div
                v-if="!isMobile"
                class="form-question-active"
                :class="moduleStatus(courseModule)"
            >
                <i
                    class="material-icons"
                    v-if="moduleStatus(courseModule) == '-active'"
                    >check</i
                >
                <i class="material-icons" v-else>hourglass_empty</i>
            </div>

            <div
                :class="[
                    isMobile ? null : moduleStatus(courseModule),
                    isMobile ? 'mobile-module-title' : 'payments-form-question'
                ]"
            >
                {{
                    isMobile
                        ? courseModule.title.toLowerCase()
                        : courseModule.title
                }}
            </div>
            <div style="margin-left: 1rem;">
                <h3>{{ courseModule.subtitle }}</h3>
                <p v-html="courseModule.description"></p>
                <div v-if="isBought">
                    <div class="course-module-player">
                        <VodPlayer
                            autoplay="false"
                            v-if="courseModule.video_url"
                            :vimeoURL="courseModule.video_url"
                        />
                    </div>
                    <div class="module-content">
                        <div style="margin-right: 1rem;">
                            <div class="webinar-button-title">
                                TEST WIEDZY O MODULE
                            </div>
                            <div
                                class="webinar-certificate-button -blue"
                                style="margin-left: 0;"
                                v-if="moduleStatus(courseModule) == '-pending'"
                                @click="startExam(courseModule)"
                            >
                                <i class="material-icons">edit</i>
                                <div v-html="`ROZPOCZNIJ TEST`" />
                            </div>
                            <div
                                class="webinar-certificate-button -disabled"
                                style="margin-left: 0;"
                                v-else
                            >
                                <i class="material-icons">check</i>
                                <div v-html="`TEST ZAKOŃCZONY`" />
                            </div>
                        </div>
                        <VodAttachments
                            :attachments="courseModule.attachments"
                            v-if="
                                courseModule.attachments &&
                                    courseModule.attachments.length > 0
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <div
            style="padding-top: 4rem;"
            class="payments-form-block -active"
            :class="{ '-disabled': !courseFinished }"
            v-if="isBought && !isMobile"
        >
            <h2>PODSUMOWANIE KURSU</h2>
            <div style="display: flex;">
                <div
                    class="webinar-certificate-button"
                    style="margin-left: 0;"
                    @click="downloadCertificate"
                >
                    <i class="material-icons">save_alt</i>
                    <div v-html="`POBIERZ ZAŚWIADCZENIE`" />
                </div>
            </div>
        </div>
        <transition name="fade">
            <Modal v-if="selectedModule.exam" @close="closeExam">
                <VodCertificateExam
                    type="course"
                    @examPassed="closeExam"
                    :webinar="selectedModule"
                />
            </Modal>
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        VodCertificateExam: () => import('../VodCertificateExam'),
        VodAttachments: () => import('@/components/utils/VodAttachments.vue')
    },
    props: {
        course: Object,
        isBought: Boolean
    },
    data() {
        return {
            selectedModule: {}
        }
    },
    computed: {
        courseFinished() {
            const finishedExams = this.$store.state.roleStorage.finishedExams
            const courseModules = this.courseModules.map(module => {
                return {
                    id: module.id,
                    key: `${this.course.uuid}-${module.id}`
                }
            })
            return courseModules.every(module => {
                return finishedExams && finishedExams[module.key]
            })
        },
        courseModules() {
            return this.course.modules
        },
        isMobile() {
            return this.$store.getters['source/isMobile']
        },
        moduleClass() {}
    },
    methods: {
        closeExam() {
            this.selectedModule = {}
        },
        startExam(module) {
            this.selectedModule = module
        },
        downloadCertificate() {
            if (!this.courseFinished) {
                return
            }
            this.$emit('getCertificate')
        },
        moduleStatus(module) {
            const finishedExams = this.$store.state.roleStorage.finishedExams
            const moduleKey = `${this.course.uuid}-${module.id}`
            const isModuleFinished = finishedExams && finishedExams[moduleKey]
            return !this.isBought || isModuleFinished ? '-active' : '-pending'
        }
    }
}
</script>
<style lang="scss" scoped>
.payments-form-question {
    font-size: 2.5rem;
    color: $accent-apple;
    padding-left: 1rem;
}
.payments-form-block {
    border-width: 0.4rem;
    position: relative;

    &.-disabled {
        opacity: 0.5;
        pointer-events: none;

        h2 {
            font-size: 2rem;
            letter-spacing: 0.1rem;
        }
    }

    &.-pending {
        border-color: $accent-orange;
    }
}
.payments-form-question {
    &.-pending {
        color: $accent-orange;
        &::after {
            height: 0.4rem;
            background: $accent-orange;
        }
    }
    &.-active {
        &::after {
            height: 0.4rem;
        }
    }
}
.form-question-active {
    height: 3rem;
    width: 3rem;
    position: absolute;
    left: -1.7rem;
    top: 40%;

    &.-pending {
        background: $accent-orange;
    }

    i {
        font-size: 2.2rem;
    }
}
.course-module-player {
    margin-top: 2rem;
}
.module-content {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
}

h3 {
    font-size: 1.6rem;
    margin: 0.2rem 0;
}
p {
    line-height: 1.3rem;
    max-width: 70%;
}
@media (max-width: 1000px) {
    .mobile {
        margin-left: -1rem;
    }
    .subtitle {
        font-size: 1.2rem;
        font-family: $header-family;
        margin-bottom: 1.5rem;
    }
    .mobile-module-title {
        color: $accent-apple;
        font-size: 1.2rem;
        font-family: $header-family;
        margin: 0.8rem 1rem;
        margin-top: 1.5rem;
        text-transform: capitalize;
    }
    h3 {
        font-family: $input-family;
        font-weight: 600;
        line-height: 120%;
    }
    p {
        font-family: $input-family;
        color: $smoked;
        max-width: 100%;
        font-size: 1.2rem;
        line-height: 135%;
    }
    .module-content {
        flex-direction: column;
    }
    .module-attachments {
        margin-top: 1rem;
        max-width: 100%;
    }
}
</style>
